import Stripe from 'stripe';

export const NON_EU_COUNTRIES_USING_EURO = [
  'BG', // Bulgaria
  'CH', // Switzerland
  'CZ', // Czechia
  'DK', // Denmark
  'GB', // United Kingdom
  'HU', // Hungary
  'IS', // Iceland
  'LI', // Liechtenstein
  'ME', // Montenegro
  'NO', // Norway
  'PL', // Poland
  'SE'  // Sweden
];

export const COUNTRIES_REQUIRING_STATE_OR_PROVINCE_FOR_TAX = [
  "US", // USA
  "CA"  // Canada
];

export const getCountryCurrency = async (countryCode: string): Promise<string> => {
  if (NON_EU_COUNTRIES_USING_EURO.includes(countryCode)) {
    return 'eur'
  }

  try {
    const stripe = new Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);

    const countrySpec = await stripe.countrySpecs.retrieve(countryCode);
    const defaultCurrency = countrySpec.default_currency;

    if (defaultCurrency === 'eur') {
      return 'eur';
    } else {
      return 'usd';
    }
  } catch (error) { }

  return 'usd';
};